import InfiniteScroll from 'react-infinite-scroll-component'

import { Card } from '@/shared/ui'
import { AppIcon } from '@/shared/ui/icons'

import { WalletMovementCard } from './WalletMovementCard'

import type { WalletMovement } from '../model/types'

type WalletMovementsInfiniteListProps = {
  movements: WalletMovement[]
  isLoading: boolean
  isReachingEnd: boolean
  size: number
  setSize?: (size: number) => void
}

export const WalletMovementsInfiniteList = ({
  movements,
  isLoading,
  isReachingEnd,
  size,
  setSize
}: WalletMovementsInfiniteListProps) => (
  <InfiniteScroll
    dataLength={movements.length}
    className="overflow-initial"
    style={{ overflow: 'initial' }}
    next={() => {
      if (!isLoading && !isReachingEnd && setSize) {
        setSize(size + 1)
      }
    }}
    hasMore={!isReachingEnd}
    loader={
      <Card className="mt-3">
        <Card.Body>
          <div className="flex w-full items-center justify-center gap-3 p-4">
            <AppIcon name="spinner-third" className="text-base text-gray-500" />
            <span className="text-base text-gray-500">
              Carregando {size > 1 ? 'mais' : ''} movimentações...
            </span>
          </div>
        </Card.Body>
      </Card>
    }
    endMessage={
      movements.length > 0 ? (
        <Card className="mt-3">
          <Card.Body>
            <div className="flex w-full items-center justify-center gap-3 p-4">
              <AppIcon name="circle-check" className="text-base text-gray-500" />
              <span className="text-base text-gray-500">
                Pronto! Todo o extrato foi carregado.
              </span>
            </div>
          </Card.Body>
        </Card>
      ) : null
    }
  >
    <div className="flex flex-col gap-3">
      {movements.map(movement => (
        <WalletMovementCard key={movement.id} {...movement} />
      ))}
    </div>
  </InfiniteScroll>
)
